"use strict";
exports.__esModule = true;
exports.uploadFile = exports.serveFile = void 0;
exports.serveFile = function (b, filename) {
    var link = document.createElement('a');
    link.href = window.URL.createObjectURL(b);
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};
exports.uploadFile = function (url, f) {
    var body = new FormData();
    body.append('file', f);
    return fetch(url, {
        method: 'POST',
        body: body
    });
};
